<template>
    <div class="frame_box">
        <iframe :src="crmurl + '/customer/showAddPanel?remote=true' + inputSuffix" class="frame" frameborder="0"></iframe>
    </div>
</template>

<script>
    export default {
        name: "opportunity",
        data() {
            return {
                iframemaskshow: false,
            }
        },
        props:{
            crmurl: {},
            inputSuffix: {}
        },
        computed: {

        },
        mounted() {

        },
        methods: {

        },
        destroyed() {

        }

    }
</script>

<style lang="less" scoped>
    .frame_box {
        position: relative;
        min-width: 360px;
        height: calc(100vh - 50px);
        z-index: 1000;
        background: #fff;

        .frame {
            width: 100%;
            height: 100%;
            background: transparent;
            transition: all 0.6;
        }

    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/opportunity.vue